import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store from './redux/store';
import { persistStore } from 'redux-persist';
import App from './App';
import Api from './services/api';
import { createBrowserHistory } from 'history';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './index.css';

window.api = new Api();

const basename = import.meta.env.BASE_URL;

let persistor = persistStore(store);

export const history = createBrowserHistory({ basename });

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={createTheme()}>
                <App />
            </ThemeProvider>
        </PersistGate>
    </Provider>
);
